import React, { useState, useEffect,useRef  } from "react";
import { styles } from "../styles/ChatList.styles";
import { useAuth } from "../context/AuthContext";
import { getChats } from "../services/chat";
import { MdGroup, MdAddComment } from "react-icons/md";
import { useSocket } from "../context/SocketContext";
import { formatDate,getCurrentDateTime,formatLogo,getLogo,getLastMessagePreview } from "../utils/utils";
import AddChat from "../components/AddChat";
import { useNavigate } from "react-router-dom";



function ChatList({isMobile,menuOpen,onSelectConversation,conversations,setConversations,selectedConversationId,selectedConversationStamp}) {
  const [searchTerm, setSearchTerm] = useState("");
  const [conversationFilter, setConversationFilter] = useState("all");
  const [activeChat, setActiveChat] = useState(null);
  const { token, stampTomador } = useAuth(); 
  const socket = useSocket();
  const [menuOpenPlus, setMenuOpenPlus] = useState(false);
  const [showNewChatPanel, setShowNewChatPanel] = useState(false);
  const [loading, setLoading] = useState(false);
  const [offsetChat, setOffsetChat] = useState(null);
  const [hasMore, setHasMore] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const listRef = useRef(null);
  const [profile, setProfile] = useState(null);
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [unreadCounts, setUnreadCounts] = useState({});
  const isFirstLoad = conversations.length === 0;
  const scrollTimeoutRef = useRef(null);
  const navigate = useNavigate();
  const normalizeChatId = (data) => {
    return (
      data?.CHATSTP ||
      data?.chatstp ||
      data?.STAMP ||
      data?.PUBLIC_ID ||
      data?.publicId ||
      data?.public_id ||
      null
    );
  };

  const getConversationKey = (conversation) => {
    return conversation?.PUBLIC_ID || conversation?.CHATSTP || conversation?.STAMP || "";
  };

  const getConversationKeys = (conversation) => {
    return [conversation?.PUBLIC_ID, conversation?.CHATSTP, conversation?.STAMP]
      .filter(Boolean)
      .map(String)
      .filter((key, index, keys) => keys.indexOf(key) === index);
  };

  const getUnreadCount = (conversation) => {
    return getConversationKeys(conversation).reduce(
      (total, key) => total + (unreadCounts[key] || 0),
      0
    );
  };

  const visibleConversations = conversationFilter === "unread"
    ? conversations.filter((conversation) => getUnreadCount(conversation) > 0)
    : conversations;

  const clearUnreadForConversation = (conversation) => {
    const keys = [conversation?.PUBLIC_ID, conversation?.CHATSTP, conversation?.STAMP].filter(Boolean);

    if (keys.length === 0) return;

    setUnreadCounts((prev) => {
      const next = { ...prev };
      keys.forEach((key) => {
        delete next[key];
      });
      return next;
    });
  };
 



  const handleScroll = async (e) => {
      if (loading || loadingMore || !hasMore) return;

      const el = e.target;

      const isBottom =
        el.scrollTop + el.clientHeight >= el.scrollHeight - 150;

      if (isBottom && !scrollTimeoutRef.current) {
        scrollTimeoutRef.current = setTimeout(async () => {
          scrollTimeoutRef.current = null;
          setLoadingMore(true);
          try {
            await fetchConversations(false, debouncedSearch);
          } finally {
            setLoadingMore(false);
          }
        }, 300); 
      }
  };


 const fetchConversations = async (reset = true, search = debouncedSearch) => {
      try {
          const isFirstLoad = conversations.length === 0;

          if (reset && isFirstLoad) {
            setLoading(true);
          }

          if (reset) {
            setOffsetChat(null);
          }

        const before = reset ? null : offsetChat;

        const { chats, hasMore } = await getChats(
          20,
          before,
          search
        );

        setHasMore(hasMore);


        setConversations(prev =>
          reset ? chats : [...prev, ...chats]
        );

        if (chats.length > 0) {
          setOffsetChat(chats[chats.length - 1].DATAENV);
        }

      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
        setLoadingSearch(false);
      }
  };
 useEffect(() => {

      const container = listRef.current;

      if (!container) return;

      container.addEventListener("scroll", handleScroll);

      return () => {
        container.removeEventListener("scroll", handleScroll);
        if (scrollTimeoutRef.current) {
          clearTimeout(scrollTimeoutRef.current);
        }
      };

  }, [loading, loadingMore, hasMore, offsetChat, debouncedSearch]);


  useEffect(() => {
      if (!socket || !token) return;

      const handleNewMessage = async (data) => {
            const incomingId = normalizeChatId(data);

            if (!incomingId) return;

            const rawMessage =
              data?.MENSAGEM ??
              data?.CONTEUDO ??
              data?.FILE ??
              data?.file ??
              "";


        

            const lastMessage = typeof rawMessage === "string"
              ? rawMessage
              : rawMessage?.message || rawMessage?.text || "";

           

            const newConversationCandidate = {
              STAMP: data?.CHATSTP || data?.chatstp || data?.STAMP || null,
              PUBLIC_ID: data?.PUBLIC_ID || data?.publicId || data?.public_id || null,
              NOME: data?.NOME || "Novo Chat",
              LOGO: data?.LOGO || null,
              TIPO: data?.TIPO || "private",
              IS_TEMP: data?.IS_TEMP ?? false,
            };

            const existingConversation = conversations?.find((conversation) =>
              conversation.PUBLIC_ID === incomingId ||
              conversation.CHATSTP === incomingId ||
              conversation.STAMP === incomingId ||
              conversation.PUBLIC_ID === newConversationCandidate.PUBLIC_ID ||
              conversation.STAMP === newConversationCandidate.STAMP ||
              conversation.CHATSTP === newConversationCandidate.STAMP
            );

            if (!existingConversation) {
               setConversations((prev) => [
                {
                  ...newConversationCandidate,
                  ...(lastMessage && lastMessage.trim() !== '' && { ULTMSG: lastMessage }),
                  DATAENV: data?.DATAENV || new Date().toISOString(),
                },
                ...prev,
              ]);
              return;
            }

            setConversations((prev) =>
              prev.map((conversation) => {
                const belongsToConversation =
                  conversation.PUBLIC_ID === incomingId ||
                  conversation.CHATSTP === incomingId ||
                  conversation.STAMP === incomingId ||
                  conversation.PUBLIC_ID === newConversationCandidate.PUBLIC_ID ||
                  conversation.STAMP === newConversationCandidate.STAMP ||
                  conversation.CHATSTP === newConversationCandidate.STAMP;

                  
                return belongsToConversation
                  ? {
                      ...conversation,
                      ULTMSG: lastMessage,
                      DATAENV: data?.DATAENV || new Date().toISOString()
                    }
                  : conversation;
              })
            );

            const senderIds = [
              data?.UTSTP,
              data?.USER,
              data?.user,
              data?.USERSTP,
              data?.utilizadorStamp,
            ]
              .filter(Boolean)
              .map(String);
            const isOwnMessage =
              String(data?.nomeUtilizador || "").trim().toUpperCase() === "EU" ||
              senderIds.includes(String(token));

            if (isOwnMessage) return;

            const isActiveConversation =
              incomingId === selectedConversationId ||
              incomingId === selectedConversationStamp;

            if (isActiveConversation) return;

            setUnreadCounts((prev) => ({
              ...prev,
              [incomingId]: (prev[incomingId] || 0) + 1,
            }));
        };



      socket.on("nova_mensagemLista", handleNewMessage);

      return () => {
        socket.off("nova_mensagemLista", handleNewMessage);
      };
  }, [socket, token, selectedConversationId]);  

  useEffect(() => {
  if (!socket) return;

  const handleNewChat = async ({ success, chatStamp, NOME, DATAENV, PUBLIC_ID, LOGO, PARTICIPANTES, TIPO, IS_TEMP }) => {
    if (!success) return;

    const normalizedId = PUBLIC_ID || chatStamp;

    setConversations(prev => {
      const existing = prev.find((c) => c.PUBLIC_ID === normalizedId || c.STAMP === chatStamp);

      if (existing) {
        return prev.map((conv) =>
          conv.PUBLIC_ID === normalizedId || conv.STAMP === chatStamp
            ? {
                ...conv,
                STAMP: chatStamp || conv.STAMP,
                PUBLIC_ID: normalizedId || conv.PUBLIC_ID,
                NOME: NOME || conv.NOME || "Novo Chat",
                LOGO: LOGO || conv.LOGO || null,
                PARTICIPANTES: PARTICIPANTES || conv.PARTICIPANTES || [],
                TIPO: TIPO || conv.TIPO || "private",
                IS_TEMP: IS_TEMP ?? conv.IS_TEMP ?? false,
                DATAENV: DATAENV || conv.DATAENV || null,
              }
            : conv
        );
      }


      return [
        {
          STAMP: chatStamp,
          PUBLIC_ID: normalizedId,
          NOME: NOME || "Novo Chat",
          LOGO: LOGO || null,
          PARTICIPANTES: PARTICIPANTES || [],
          TIPO: TIPO || "private",
          IS_TEMP: IS_TEMP ?? false,
          ULTMSG: "",
          DATAENV: DATAENV || null,
        },
        ...prev,
      ];
    });

    setActiveChat(chatStamp);

    onSelectConversation({
      STAMP: chatStamp,
      PUBLIC_ID: normalizedId,
      NOME: NOME || "Novo Chat",
      LOGO: LOGO || null,
      PARTICIPANTES: PARTICIPANTES || [],
      TIPO: TIPO || "private",
      IS_TEMP: IS_TEMP ?? false

    });
  };

  socket.on("createChatResult", handleNewChat);

  return () => {
    socket.off("createChatResult", handleNewChat);
  };
}, [socket, onSelectConversation]);


useEffect(() => {
  if (!socket) return;

  const handleChatUpdate = ({ chatstp, NOME, LOGO }) => {
    setConversations(prev =>
      prev.map(conv =>
        conv.STAMP === chatstp
          ? {
              ...conv,
              NOME: NOME ?? conv.NOME,
              LOGO: LOGO ?? conv.LOGO,
            }
          : conv
          
      )
    );
  };

 
  socket.on("chatAtualizado", handleChatUpdate);

  return () => {
    socket.off("chatAtualizado", handleChatUpdate);
  };
}, [socket]);



 
  useEffect(() => {
    if (!socket || !token) return;

    const handleUpdate = async () => {
      try {
        const data = await getChats();
        setConversations(data.chats);
      } catch (err) {
        console.error(err);
      }
    };

    socket.on("participantsResult", handleUpdate);
    return () => {
      socket.off("participantsResult", handleUpdate);
    };
  }, [socket, token]);

  useEffect(() => {
    if (!selectedConversationId && !selectedConversationStamp) return;

    setUnreadCounts((prev) => {
      const next = { ...prev };
      [selectedConversationId, selectedConversationStamp].filter(Boolean).forEach((key) => {
        delete next[key];
      });
      return next;
    });
  }, [selectedConversationId, selectedConversationStamp]);

  useEffect(() => {
    if (!token) return;
    fetchConversations(true, "");
  }, [token]);


  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(searchTerm);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchTerm]);

  // Fetch quando o search debounced muda
  useEffect(() => {
    if (!token) return;
    fetchConversations(true, debouncedSearch);
  }, [debouncedSearch, token]);

 
  return (
  <div style={styles.container(isMobile, menuOpen)}>
  {loading && (
       <div style={styles.loadingOverlay}>
       <div style={styles.spinner} />
      </div>
   )}  


  {showNewChatPanel ? (
    <AddChat
      socket = {socket}
      isMobile={isMobile}
      onClose={() => setShowNewChatPanel(false)}
      onNewChat={(chat) => {

       
          if (!chat?.TEMP_INDEX) return;


          const existingChat = (conversations ?? []).find(c =>
          c?.TIPO === "private" &&
            c?.NOME?.trim().toLowerCase() === chat?.NOME?.trim().toLowerCase() 
          );


          if (existingChat) {
            onSelectConversation(existingChat);
            setShowNewChatPanel(false);
            return;
          }

         


          onSelectConversation({
            STAMP: chat.STAMP,
            NOME: chat.NOME,
            LOGO: chat.LOGO,
            STAMPUTILIZADOR: chat.STAMPUTILIZADOR,
            STAMPTOMADOR: chat.STAMPTOMADOR,
            PARTICIPANTES: chat.PARTICIPANTS,
            TIPO: chat.TIPO,
            IS_TEMP : chat.IS_TEMP
          });
          setShowNewChatPanel(false);
        }}  
         
    />
  ) : (
    <>
      {/* 🔥 HEADER */}
      <div style={styles.header}>
        <h2 style={styles.h2(isMobile)}>Conversas</h2>
          <button
            style={styles.addButton}
            onClick={() => setShowNewChatPanel(true)} 
          >
          <MdAddComment size={18} />
        </button>
      </div>

      {/* 🔍 SEARCH */}
      <div style={styles.searchContainer(isMobile)}>
        <div style={{ position: "relative", width: "100%" }}>
          <svg
            style={{
              position: "absolute",
              left: 10,
              top: "50%",
              transform: "translateY(-50%)",
              width: 20,
              height: 20,
              fill: "#9ca3af",
              ...styles.svg(isMobile) 
            }}
            viewBox="0 0 24 24"
          >
            <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
          </svg>
          <input
            type="text"
            placeholder="Pesquisar..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              ...styles.input(isMobile),
              paddingLeft: 35 // espaço para o ícone
            }}
            onFocus={(e) => (e.target.style.border = "1px solid #2563eb")}
            onBlur={(e) => (e.target.style.border = "1px solid #e5e7eb")}
          />
        </div>
      </div>

      <div
        role="tablist"
        aria-label="Filtro de conversas"
        style={{
          display: "flex",
          gap: 8,
          margin: isMobile ? "0 3% 10px" : "0 0 12px",
          borderBottom: "1px solid #e5e7eb",
        }}
      >
        {[
          { value: "all", label: "Tudo" },
          { value: "unread", label: "Não lidas" },
        ].map((filter) => {
          const isSelected = conversationFilter === filter.value;
          const unreadTotal = Object.values(unreadCounts).reduce(
            (total, count) => total + count,
            0
          );

          return (
            <button
              key={filter.value}
              type="button"
              role="tab"
              aria-selected={isSelected}
              onClick={() => setConversationFilter(filter.value)}
              style={{
                border: "none",
                borderBottom: isSelected ? "2px solid #2563eb" : "2px solid transparent",
                background: "transparent",
                color: isSelected ? "#1d4ed8" : "#6b7280",
                cursor: "pointer",
                fontSize: isMobile ? 12 : 13,
                fontWeight: isSelected ? 700 : 500,
                padding: "8px 4px",
              }}
            >
              {filter.label}
              {filter.value === "unread" && unreadTotal > 0 ? ` (${unreadTotal})` : ""}
            </button>
          );
        })}
      </div>

      {/* 📭 EMPTY STATE */}
      {visibleConversations.length === 0 && (
        <div style={styles.emptyState}>
          {conversationFilter === "unread"
            ? "Nenhuma conversa não lida"
            : "Nenhuma conversa encontrada"}
        </div>
      )}


      <div
        style={{
          height: "100vh",
          overflowY: "auto",
        }}
        onScroll={handleScroll}
      >

      {/* 💬 LISTA */}
      <ul ref={listRef} style={styles.ul}>
        {visibleConversations.map((conv) => {
          const conversationKey = getConversationKey(conv);
          const unreadCount = getUnreadCount(conv);
          const isActive = selectedConversationId === conversationKey || selectedConversationStamp === conversationKey;
          const matchingParticipant = conv.PARTICIPANTES?.find(
            (participant) =>
              String(participant?.NOME || "").trim().toLowerCase() ===
              String(conv.NOME || "").trim().toLowerCase()
          );
          const conversationLogo = matchingParticipant?.FOTO || conv.LOGO;
          return (
            
            <li
              key={conv.STAMP}
              style={styles.li(isMobile, isActive)}
              onClick={() => {
                clearUnreadForConversation(conv);
                onSelectConversation({
                  STAMP: conv.STAMP,
                  PUBLIC_ID: conv.PUBLIC_ID,
                  NOME: conv.NOME,
                  LOGO: conversationLogo,
                  TIPO : conv.TIPO
                });
              }}
              onMouseEnter={(e) => {
                if (!isActive)
                  e.currentTarget.style.background = "#f3f4f6";
              }}
              onMouseLeave={(e) => {
                if (!isActive)
                  e.currentTarget.style.background = "transparent";
              }}
            >
             
             {/* Avatar */}
            <div
              style={{
                ...styles.img(isMobile),
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#e5e7eb",
                overflow: "hidden",
              }}
            >
              {conversationLogo && (
                <img
                  src={conversationLogo}
                  alt={conv.NOME}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    display: "block",
                  }}
                  onError={(event) => {
                    event.currentTarget.style.display = "none";
                    event.currentTarget.nextElementSibling.style.display = "flex";
                  }}
                />
              )}
              <span
                style={{
                  display: conversationLogo ? "none" : "flex",
                  width: "100%",
                  height: "100%",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <MdGroup size={18} color="#6b7280" />
              </span>
            </div>

              {/* Conteúdo */}
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={styles.name(isMobile)}>
                    {conv.TIPO === "private"
                      ? conv.PARTICIPANTES?.find(p => !p.isMe)?.NOME || conv.NOME
                      : conv.NOME}
                </div>
                <div style={styles.lastMessage(isMobile)}>
                  {getLastMessagePreview(conv.ULTMSG)}
                </div>
              </div>

              {/* Hora */}
              <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", marginLeft: 8 }}>
                <div style={styles.time(isMobile)}>
                  {formatDate(conv.DATAENV) ?? formatDate(conv.DATACRIA)}
                </div>
                {unreadCount > 0 && (
                  <div style={styles.badge}>{unreadCount > 99 ? "99+" : unreadCount}</div>
                )}
              </div>
            </li>
          );
        })}
      </ul>
          {loadingMore && (
          <div style={styles.loadingMoreContainer}>
            <div style={styles.spinnerSmall} />
          </div>
        )}

        {loadingSearch && (
           <div style={styles.loadingMoreContainer}>
            <div style={styles.spinnerSmall} />
          </div>
          )}
      </div>
    </>
    
  )}
</div>
  );
}

export default ChatList;